import React from 'react';

interface ICrossIconProps {
	size?: string;
	fill?: string;
	className?: string;
}

export const CrossIcon = ({ size = '24', fill, className }: ICrossIconProps) => (
	<svg
		role="img"
		width={size}
		height={size}
		className={className}
		viewBox="0 0 24 24"
		fill="none"
		aria-labelledby="closeCross">
		<title id="closeCross">close cross</title>
		<path d="M5 5L19 19" stroke={fill || '#707070'} strokeWidth="2" strokeLinejoin="round" />
		<path d="M19 5L5.00001 19" stroke={fill || '#707070'} strokeWidth="2" strokeLinejoin="round" />
	</svg>
);
